// features/usuarios/api/usuarios.api.js
// Capa de API para gestión de usuarios.
// Reemplaza gradualmente: usuario.resource.js + profile.resource.js
//
// Endpoints mapeados desde BaseService + UsuarioResource:
//   GET    /profile/users              → getAll
//   GET    /invitations                → getInvitations
//   POST   /profile/users             → create
//   PUT    /profile/users/:id          → update
//   DELETE /profile/users/:id          → remove
//   PUT    /user/me                    → updateMe
//   PUT    /me/password                → changePassword  (ruta base /api)
//   GET    /profile/users/names        → getNames

import { api } from '../../../api/client';

export const usersApi = {
  /** Lista todos los usuarios del sistema */
  getAll: () => api.get('/profile/users'),

  /** Lista nombres/ids simplificados (para selects) */
  getNames: () => api.get('/profile/users/names'),

  /** Obtiene invitaciones pendientes */
  getInvitations: (dataSearch) => api.post('/invitations/search', dataSearch),

  search: (dataSearch={}) => api.post('/users/search', dataSearch),
  /**
   * Crea un usuario
   * @param {object} data
   */
  create: (data) => api.post('/users', data),

  /**
   * Actualiza un usuario por id
   * @param {string|number} id
   * @param {object} data
   */
  update: (id, data) => api.put(`/users/${id}`, data),

  /**
   * Elimina un usuario por id
   * @param {string|number} id
   */
  remove: (id) => api.delete(`/users/${id}`),

  /** Actualiza el perfil del usuario autenticado */
  updateMe: (data) => api.put('/user/me', data),

  /**
   * Cambia la contraseña del usuario autenticado
   * @param {{ currentPassword: string, newPassword: string }} data
   */
  changePassword: (data) => api.put('/me/password', data),

  /** Activa un usuario */
  activate: (id) => api.put(`/users/${id}/activate`),

  /** Desactiva un usuario */
  deactivate: (id) => api.put(`/users/${id}/deactivate`),

  /** Cancela una invitación */
  cancelInvitation: (id) => api.delete(`/invitations/${id}`),

  /** Crea una invitación */
  createInvitation: (data) => api.post('/invitations', data),
  updateInvitation: (id, data) => api.put(`/invitations/${id}`, data),
//para el filtro
  getNames:()=>api.get('/users/getNames')

};
